import { useCallback, useEffect, useRef, useState } from "react";
import ProductCard from "./ProductCard";
import "./ProductCarousel.css";

function ProductCarousel({ products = [], onSelect, configuracionTienda }) {
  const trackRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateArrows = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const { scrollLeft, scrollWidth, clientWidth } = track;
    setCanPrev(scrollLeft > 4);
    setCanNext(scrollLeft + clientWidth < scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateArrows();
    const track = trackRef.current;
    if (!track) return;
    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    return () => {
      track.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [updateArrows, products.length]);

  const scrollByCards = (dir) => {
    const track = trackRef.current;
    if (!track) return;
    const amount = Math.max(track.clientWidth * 0.85, 220);
    track.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  if (!products.length) return null;

  return (
    <div className="pcar">
      <button
        type="button"
        className="pcar__nav pcar__nav--prev"
        onClick={() => scrollByCards(-1)}
        disabled={!canPrev}
        aria-label="Productos anteriores"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      <div className="pcar__track" ref={trackRef}>
        {products.map((p) => (
          <div className="pcar__item" key={p.producto_id}>
            <ProductCard
              data={p}
              configuracionTienda={configuracionTienda}
              onClick={() => onSelect?.(p)}
            />
          </div>
        ))}
      </div>

      <button
        type="button"
        className="pcar__nav pcar__nav--next"
        onClick={() => scrollByCards(1)}
        disabled={!canNext}
        aria-label="Más productos"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  );
}

export default ProductCarousel;
